import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify, {
  theme: {
    primary: '#2196F3',
    secondary: '#0d47a1',
    success: '#1B5E20',
    error: '#AA0000',
    warning: '#FFB300',
    info: '#757575',
  },
});

export default new Vuetify({});
